define('app/filters/controls/BlankFilterControl',['require','glu/itemView','hbs!./BlankFilterControl.hbs'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView');

	return ItemView.extend({
		template: require('hbs!./BlankFilterControl.hbs'),
		tagName: 'span',
		events: {
			'change [name=value]': 'updateModel'
		},

		initialize: function() {
			this.model.setArity(0);
		},

		serializeData: function() {
			return this;
		},


		value: function() {
			return this.model.getValue(0);
		},

		updateModel: function() {
			this.model.setValue(0, this.$el.find('[name=value]').val());
		}
	});

});

